import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HTTP_INTERCEPTORS } from "@angular/common/http";

import { TranslateModule, TranslateLoader } from "@ngx-translate/core";

import { environment } from "src/environments/environment";

import { I18nService, HttpLoaderFactory } from "./core/i18n";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginModule } from './features/login/login.module';
import { DomainModule } from './domains/domains.module';
import { DashboardModule } from './features/dashboard/dashboard.module';
import { SalesModule } from './features/sales/sales.module';
import { SharedModule } from './shared/shared.module';
import { MarketingModule } from './features/marketing/marketing.module';
import { KpiModule } from './features/kpi/kpi.module';
import { ReviewsModule } from './features/reviews/reviews.module';
import { GenericErrorHandlingInterceptor } from './core/interceptors/generic-error-handling-interceptors';
import { IntegrationsModule } from './features/integrations/integrations.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LoginModule,
    DomainModule,
    DashboardModule,
    SalesModule,
    MarketingModule,
    KpiModule,
    ReviewsModule,
    IntegrationsModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  bootstrap: [AppComponent],
  providers: [{
    provide: APP_INITIALIZER,
    useFactory: (i18n: I18nService) => {
      return () => {
        i18n.init(
          environment.defaultLanguage,
          environment.supportedLanguages
        );
      };
    },
    deps: [I18nService],
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: GenericErrorHandlingInterceptor,
    multi: true
  }]
})
export class AppModule { }
